<template>
  <div class="p-8 flex flex-col gap-4 justify-center mt-[40px] rounded-[12px] bg-blue-bg">
    <div v-html="mgs" class="text-center text-darkGrey text-base leading-[1.2em]" >

    </div>
    <a :href="websiteLink" class="btn btn__primary max-w-[165px] w-full mx-auto" target="_blank" rel="noreferrer">
      Go to website
    </a>
  </div>

</template>
<script setup>
import {defineProps} from "vue";
const config = useRuntimeConfig()

const websiteLink = config.public.websiteLink;
const props = defineProps({
  mgs: {type: String, default: ''},
})
</script>